module.exports = __webpack_public_path__ + "static/media/alerta-infracciones-verde.6cf2620d.svg";